var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCustomersOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 20.8542V14.8542H16V20.8542H19V4.85425H5V20.8542H8ZM10 20.8542H14V16.8542H10V20.8542ZM21 20.8542H23V22.8542H1V20.8542H3V3.85425C3 3.58903 3.10536 3.33468 3.29289 3.14714C3.48043 2.9596 3.73478 2.85425 4 2.85425H20C20.2652 2.85425 20.5196 2.9596 20.7071 3.14714C20.8946 3.33468 21 3.58903 21 3.85425V20.8542ZM11 8.85425V6.85425H13V8.85425H15V10.8542H13V12.8542H11V10.8542H9V8.85425H11Z",
    fill: "#EE7203"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomersOrange);
export default __webpack_public_path__ + "static/media/icon-customers-orange.118758bcdf213c63342204f03bef2d21.svg";
export { ForwardRef as ReactComponent };